export default function escapeHandle(e) {
  if (e.key === 'Escape') {
    e.target.blur();
  }
}
